//# sourceMappingURL=events.mjs.map
/// <reference types="./events.d.mts" />
import * as $file from "../../magellan/magellan/file.mjs";
import * as $attribute from "../../redraw_dom/redraw/dom/attribute.mjs";
import * as $events from "../../redraw_dom/redraw/dom/events.mjs";
import * as $unsafe from "../../tiamat/gleam/unsafe.mjs";
import { Ok } from "../gleam.mjs";

export function on_files_change(on_change) {
  return $events.on_change(
    (event) => {
      let event$1 = $unsafe.coerce(event);
      let $ = $file.from_event(event$1);
      if ($ instanceof Ok) {
        let files = $[0];
        on_change(files);
        return undefined;
      } else {
        return undefined;
      }
    },
  );
}
